<template>
  <footer
    class="m-footer"
    v-if="tempSett.bottomConfig.visible == 1 && loadingCompleted"
  >
    <pre>{{ tempSett.bottomConfig.bottomContent }}</pre>
    <a
      :href="tempSett.bottomConfig.linkUrl || 'javascript:;'"
      target="_blank"
      >{{ tempSett.bottomConfig.linkText }}</a
    >
  </footer>
</template>

<script>
import Bus from "../utils/eventBus";
export default {
  name: "Footer",
  data() {
    return {
      tempSett: {},
      loadingCompleted: true
    };
  },
  created() {
    this.tempSett = this.$store.getters.getterTempConfig;
    Bus.$on("actionsLoadingCompleted", data => {
      this.loadingCompleted = data;
    });
  },
  computed: {
    tempConfig() {
      return this.$store.getters.getterTempConfig;
    }
  },
  watch: {
    tempConfig(val) {
      this.tempSett = val;
    }
  }
};
</script>

<style scoped></style>
